import { tabAccessControl } from "../../../_helpers/access-control";


function ProductListTabs() {
  return [
    {
      text: "All",
      path: `/product`,
      applicationFeatureCode: "Product",
    },
    {
      text: "Stock Summary",
      path: `/stock-summary`,
      applicationFeatureCode: "StockSummary",
    },
    {
      text: "Item Movements",
      path: `/item-movements`,
      applicationFeatureCode: "ItemMovements",
    },
    {
      text: "Batch Details",
      path: `/batch-details`,
      applicationFeatureCode: "ProductBatchManagement",
    },
    {
      text: "Batch Stock",
      path: `/report-product-batch-stock`,
      applicationFeatureCode: "ReportGridProductBatchStock",
    },
    {
      text: "Batch Movements",
      path: `/batch-movements`,
      applicationFeatureCode: "ReportBatchMovements",
    },
  ]
}


function GetIndexByTabName(tabName, id) {
  return tabAccessControl(ProductListTabs(id)).findIndex((x) => x.text == tabName);
}

export { ProductListTabs, GetIndexByTabName };